import {
  webinarAnalyticsRepo,
  type WebinarAnalyticsSnapshot,
  type WebinarQAItem,
} from './webinar-analytics.repo'

/**
 * Service facade for webinar analytics data.
 * Components and stores should call methods here rather than reaching into
 * the repo directly. When the real API lands, swap the repo implementation
 * (or add a remote one and keep this service signature stable).
 */
export const webinarAnalyticsService = {
  async getSnapshot(id: string): Promise<WebinarAnalyticsSnapshot> {
    if (!id) throw new Error('Webinar id is required')
    return webinarAnalyticsRepo.getById(id)
  },
  async listQA(id: string): Promise<WebinarQAItem[]> {
    if (!id) throw new Error('Webinar id is required')
    return webinarAnalyticsRepo.listQA(id)
  },
}

export type { WebinarAnalyticsSnapshot, WebinarQAItem } from './webinar-analytics.repo'
